import './forgot-password-form.styles.scss';
import { useState } from 'react';
import { Button } from '@mui/material';
import { forgotPassword } from '../../service/authentication.service';
import RoundedBox from '../rounded-box/rounded-box.component';
import FormField from '../form-field/form-field.component';
import Loader from '../loader/loader.component';

const defaultFormFields = {
    email: ''
};

const defaultErrors = {
    email: ''
};

const ForgotPasswordForm = () => {
    const [formFields, setFormFields] = useState(defaultFormFields);
    const [errors, setErrors] = useState(defaultErrors);
    const [isLoading, setIsLoading] = useState(false);
    const [displayFeedback, setDisplayFeedback] = useState(false);

    const { email } = formFields;

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value});
    };

    const isFormValid = () => {
        let isValid = true;
        let newErrors = defaultErrors;

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors = {
                ...newErrors,
                email: "E-mail inválido"
            };
            
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (isFormValid()) {
            setIsLoading(true);
            forgotPassword(email)
                .then(() => setDisplayFeedback(true))
                .catch(() => 
                    setErrors({
                        ...defaultErrors,
                        email: 'E-mail inválido'
                    }))
                .finally(() => setIsLoading(false));
        }
    };

    const getErrorMessage = (fieldName) => {
        return !!errors ? errors[fieldName] : null;
    };

    return (
        <div>
            {
                isLoading ? (
                    <Loader/>
                ) : displayFeedback ? (
                    <RoundedBox className='forgot-password-form-container'>
                        <label className='title'>
                            E-mail de recuperação de senha enviado com sucesso!
                        </label>
                    </RoundedBox>
                ) : (
                    <RoundedBox className='forgot-password-form-container'>
                        <form className='forgot-password-form' onSubmit={handleSubmit}>
                            <label className='title'>Preencha seu e-mail:</label>
                            <FormField
                                darkBackground
                                label='E-mail'
                                name='email'
                                type='email'
                                required
                                value={email}
                                onChange={handleChange}
                                errorMessage={getErrorMessage('email')}/>
                            <div className='footer'>
                                <Button type='submit' className='send button' variant='contained' size='small'>Enviar</Button>
                            </div>
                        </form>
                    </RoundedBox>
                )
            }
        </div>
    )
}

export default ForgotPasswordForm;